export default "__VITE_ASSET__bf0ffa06__"